import React from 'react'
import styled from "styled-components";
import { connect } from "react-redux"
import i18next from 'i18next';
// @ts-ignore
import { CWBModal } from 'cwb-react';
import {withI18n} from "react-i18next";

const ConfirmModal = ({ title, message, onConfirm, onCancel, buttons, closeModal, t }: any) => (
    <StyledModal
        className={"cwb-modal-danger"}
        title={title}
        body={message}
        hideModal={onCancel || closeModal}
        isOpen={true}
        buttons={buttons || [
          <StyledButton key="cancel" className="cwb-btn-modal cwb-btn-primary" onClick={onCancel || closeModal}>{t('Cancel')}</StyledButton>,
          <StyledButton key="ok" className="cwb-btn-modal cwb-btn-danger" onClick={onConfirm}>{t('Ok')}</StyledButton>
        ]}
    >
      {message}
    </StyledModal>
)

const StyledModal = styled(CWBModal)`
  @media (min-width: 576px) {
    max-width: 420px !important;
  }
  .modal-body{
    padding: 12px 0 24px 0 !important;
    height: auto !important;
  }
  
  .modal-content{
    padding-bottom: 20px;
  }
`

const StyledButton = styled.button`
  min-width: 80px !important;
  
  &:first-child{
    margin-right: 16px !important;
  }
`

ConfirmModal.defaultProps = {
  title: i18next.t('Confirm'),
  message: i18next.t('Are you sure'),
}

interface DispatchProps {
  closeModal: () => void
}

function mapDispatchToProps(dispatch: any): DispatchProps {
  return {
    closeModal: dispatch.modal.closeModal
  };
}

export default connect(null, mapDispatchToProps)(withI18n() (ConfirmModal))
